import { Component } from '@angular/core';
import { CalculationResource } from './model/calculationResource';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'wizard-marida';

  step: number = 1;
  services!: Array<number>;

  calculation!: CalculationResource | undefined;

  next(): void {
    if( this.step < 4 ){
      this.step = this.step+1
    }
  }

  finish(): void {
    this.calculation = undefined;
    if( this.step < 5 ){
      this.step = this.step+1
    }
  }

  restart(): void {
    this.step = 1
  }

  restartAfterChange(): void {
    this.calculation = undefined;
    this.step = 1;
  }

  back(): void {
    if( this.step > 1 ){
      this.step = this.step-1
    }
  }

  setStep(step: number): void {
    this.step = step
    console.log('step', step)
  }

  updateCalculation($event: any): void{
    this.calculation = $event;
    console.log(this.calculation);
    this.step = 2;
  }

}
